import { Switch as RadixSwitch } from 'radix-ui';
import { cn } from '../lib/cn';

export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
  'aria-label'?: string;
  'aria-describedby'?: string | undefined;
  disabled?: boolean;
}

export function Switch({ checked, onCheckedChange, id, disabled, ...aria }: SwitchProps) {
  return (
    <RadixSwitch.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      {...(disabled === undefined ? {} : { disabled })}
      {...aria}
      className={cn(
        'relative inline-flex h-4.5 w-8 shrink-0 items-center rounded-full border border-border-strong bg-bg-4 transition-colors duration-100 outline-none',
        'focus-visible:ring-2 focus-visible:ring-focus data-[state=checked]:border-accent data-[state=checked]:bg-accent disabled:opacity-50',
      )}
    >
      <RadixSwitch.Thumb className="block size-3.5 translate-x-0.5 rounded-full bg-on-solid shadow-thumb transition-transform duration-100 data-[state=checked]:translate-x-[15px]" />
    </RadixSwitch.Root>
  );
}
